import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './ModalePromo.module.scss';
import { logVisit, logFormChange } from '../../services/reportAPI';

const ModalePromo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasLoggedView, setHasLoggedView] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsOpen(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isOpen && !hasLoggedView) {
      logVisit({ action: 'view', label: 'ModalePromo' });
      setHasLoggedView(true);
    }
  }, [isOpen, hasLoggedView]);

  const handleClick = () => {
    logFormChange({ action: 'click', label: 'ModalePromo' });
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={() => setIsOpen(false)}>
          &times;
        </button>
        <h1>Votre site pro passe en mode festival</h1>
        <h2>75 € de réduction sur votre site onepage</h2>
        <p>
          À l’occasion de l'<strong>Insane Festival</strong>, bénéficiez de 75 € de remise immédiate sur votre site professionnel d'une valeur de 450 € HT.
        </p>
        <p><strong>→ Soit seulement 375 € HT !</strong></p>
        <small>
          Offre valable pour toute commande passée jusqu’au <em>29/06/2025</em>.<br />
        </small>
        <Link to="/onepage-project"><button className={styles.cta} onClick={handleClick}>Je veux mon site à prix festival !</button></Link>
      </div>
    </div>
  );
};

export default ModalePromo;
